import loadable from '@loadable/component';

export const CbqSiteWrapper = loadable(
  () => import(/* webpackChunkName: "cbq-site" */ './CbqSiteWrapper'),
);
